/**
 * Home promo / collection-circle marquees — honor CMS loop_duration_ms on
 * Prestige <marquee-text>.
 *
 * 2026-08-08: switched from pre-setting a computed `speed` attribute to a
 * post-init correction via KeyframeEffect.updateTiming() — see prior history
 * in git for the racing/1000x bug this fixed.
 *
 * 2026-08-27: added viewport-proportional speed scaling. The configured
 * loop_duration_ms sets the speed at the PHONE reference width (390px). On
 * wider screens the same px/s looked slower because more of the viewport
 * is covered per cycle; this correction scales the duration inversely with
 * viewport width so the perceived relative speed (viewport-widths/s) is the
 * same on every device:
 *
 *   effectiveDuration = baseDuration × (REF_WIDTH / window.innerWidth)
 *
 * A resize listener re-applies the correction whenever the viewport changes.
 */
(function () {
  // Phone reference width — the viewport at which loop_duration_ms is "correct".
  var REF_WIDTH = 390;

  function clampMs(raw, minMs) {
    var min = minMs || 20;
    var ms = parseInt(raw, 10);
    if (!Number.isFinite(ms) || ms < min) return 24000;
    if (ms > 120000) return 120000;
    return ms;
  }

  function desiredDurationMs(mq) {
    var minMs = mq.classList.contains('eros-cms-circle--marquee') ? 8000 : 20;
    var base = clampMs(mq.getAttribute('data-loop-duration-ms'), minMs);
    // Desktop intentionally slower: multiply duration by vwScale^0.2 so
    // wider screens take longer per lap (27% slower at 1280px vs 390px).
    var vwScale = Math.pow(Math.max(window.innerWidth / REF_WIDTH, 0.5), 0.2);
    return Math.round(base * vwScale);
  }

  function findScrollerAnimation(mq) {
    if (!mq.shadowRoot) return null;
    var scroller = mq.shadowRoot.querySelector('[part="scroller"]');
    if (!scroller) return null;
    var anims = scroller.getAnimations();
    return anims.length ? anims[0] : null;
  }

  // Applies the viewport-scaled duration. Does NOT guard with the one-time
  // erosLoopApplied flag so resize can re-correct.
  function applyDuration(mq) {
    var anim = findScrollerAnimation(mq);
    if (!anim || !anim.effect) return false;
    anim.effect.updateTiming({ duration: desiredDurationMs(mq) });
    mq.dataset.erosLoopApplied = '1';
    return true;
  }

  /**
   * The animation only exists once theme.js's initialize_fn's inView()
   * callback has fired (element scrolled to within 400px of the viewport).
   * We arm an IntersectionObserver with the same margin so the correction
   * is driven by the real trigger, not a guessed timeout.
   */
  function watch(mq) {
    if (applyDuration(mq)) return;
    var quickTries = 0;
    var quickTimer = window.setInterval(function () {
      quickTries += 1;
      if (applyDuration(mq) || quickTries >= 20) {
        window.clearInterval(quickTimer);
        if (mq.dataset.erosLoopApplied !== '1') armObserver(mq);
      }
    }, 50);
  }

  function armObserver(mq) {
    if (typeof IntersectionObserver !== 'function') return;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var tries = 0;
          var timer = window.setInterval(function () {
            tries += 1;
            var done = applyDuration(mq);
            if (done || tries >= 40) {
              window.clearInterval(timer);
              if (done) observer.disconnect();
            }
          }, 50);
        });
      },
      { rootMargin: '400px' }
    );
    observer.observe(mq);
  }

  function run() {
    document.querySelectorAll('marquee-text[data-loop-duration-ms]').forEach(watch);
  }

  run();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  }

  // Re-apply when viewport is resized (e.g. browser window dragged wider).
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      document.querySelectorAll('marquee-text[data-loop-duration-ms]').forEach(applyDuration);
    }, 150);
  });
})();
